import date from "date-and-time";

const defaultDateFormat = "MM/DD/YYYY, HH:mm";
const vesselDate = "MM/DD/YYYY";
const vesselTime = "HH:mm";

export const removeOffsetFromDateString = (dateStr: string): string => {
  const format = dateStr.substring(0, 16);
  return format;
};

export const isValidString = (value: any): boolean => {
  return value !== null && value !== undefined && value.trim() !== "";
};

export const dateFormatWithoutOffset = (now: string, format?: string): string => {
  if (isValidString(now)) {
    const dateTime = new Date(removeOffsetFromDateString(now));
    const formattedDate = date.format(dateTime, format ?? defaultDateFormat);
    return formattedDate;
  }
  return "";
};

// Create a function to format the date and time expecting Date object
export const dateFormatter = (dateValue: string, format?: string): string => {
  // Format the date using the provided format of type Date
  const formattedDate = date.format(new Date(dateValue), format ?? vesselDate);
  return formattedDate;
};

export const vesselActualDateFormatter = (actual: string, estimated: string): string => {
  if (isValidString(actual)) {
    return formatter(actual, vesselDate);
  } else if (isValidString(estimated)) {
    return formatter(estimated, vesselDate);
  }
  return "";
};

export const vesselActualTimeFormatter = (actual: string, estimated: string): string => {
  if (isValidString(actual)) {
    const date = formatter(actual, vesselTime);
    return date;
  } else if (isValidString(estimated)) {
    const date = formatter(estimated, vesselTime);
    return date;
  }
  return "";
};

export const vesselTimeDifferentiate = (actual: string, estimated: string, sendDeparture = false): string => {
  if (isValidString(actual)) {
    return sendDeparture ? "ATD" : "ATA";
  } else if (isValidString(estimated)) {
    return sendDeparture ? "ETD" : "ETA";
  }
  return "";
};

export const getDateBgColor = (actual: string, estimated: string): string => {
  if (isValidString(actual)) {
    return "actual";
  } else if (isValidString(estimated)) {
    return "estimated";
  }
  return "";
};

export const getDateIcon = (actual: string, estimated: string): string => {
  if (isValidString(actual)) {
    return "check";
  } else if (isValidString(estimated)) {
    return "clock";
  }
  return "";
};

export const getDateIconColor = (actual: string, estimated: string): string => {
  if (isValidString(actual)) {
    return "#ff6441";
  } else if (isValidString(estimated)) {
    return "#42b0d5";
  }
  return "";
};

export const vesselScheduleDateFormatter = (schedule: string): string => {
  if (isValidString(schedule)) {
    return formatter(schedule, vesselDate);
  }
  return "";
};

export const vesselScheduleTimeFormatter = (schedule: string): string => {
  if (isValidString(schedule)) {
    return formatter(schedule, vesselTime);
  }
  return "";
};

export const formatter = (dateString: string, format?: string): string => {
  const dateTime = new Date(removeOffsetFromDateString(dateString));
  const formattedDate = date.format(dateTime, format ?? vesselDate);
  return formattedDate;
};
